const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConsole1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 835.53 444.39",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g3960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3962",
    d: "M142.67,209.88H104.4V175.76a7.91,7.91,0,0,1,3.66-6.71c4.14-2.8,11.09-6.94,15.47-6.94s11.34,4.14,15.48,6.94a7.91,7.91,0,0,1,3.66,6.71v34.12",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3966",
    d: "M142.67,209.64H111c9.63-.86,16.21-2.2,20.72-5.73,6-4.63,6-23.77,4.88-27.55a33.31,33.31,0,0,0-6.71-12.55,58.18,58.18,0,0,1,9.14,5.24,7.91,7.91,0,0,1,3.66,6.71v33.88",
    style: {
      fill: "#eecaac"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3970",
    d: "M106.82,191.57h0c-.84-1.21-.36-13.29,0-16.67s7.13-7.73,11.24-7.73h0c1.08,0-3.51,4-6.41,10.14s-4.34,14.26-4.83,14.26",
    style: {
      fill: "#f5ddc9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3974",
    d: "M147.79,209.92a.9.9,0,0,0-.61-.25h-46c-.25,0-.37.12-.62.25-5.26,4.89-1.83,11,2.94,11h8.08a.74.74,0,0,1,.49,1.34,6.28,6.28,0,0,0-2.21,5.63,6.55,6.55,0,0,0,5,5.39.79.79,0,0,1,.49,1.22,5.32,5.32,0,0,0-1,3.06,4.7,4.7,0,0,0,1,2.93.78.78,0,0,1-.12,1.1,6.58,6.58,0,0,0-2.7,5.51,6.32,6.32,0,0,0,3.55,6,.81.81,0,0,1,.37,1.1A7.22,7.22,0,0,1,110,258c-3.31,0-6.24,2.32-6.49,5.38a6.13,6.13,0,0,0,6.24,6.61h28.75a6.13,6.13,0,0,0,6.24-6.61,6.38,6.38,0,0,0-6.48-5.38h0a7.47,7.47,0,0,1-6.49-3.79.81.81,0,0,1,.37-1.1,6.32,6.32,0,0,0,3.55-6A6.57,6.57,0,0,0,133,241.6a.8.8,0,0,1-.25-1.1,5.56,5.56,0,0,0,1-2.93,4.81,4.81,0,0,0-1-3.06.75.75,0,0,1,.49-1.22,6.31,6.31,0,0,0,2.82-11,.74.74,0,0,1,.48-1.34h8.2c4.9,0,8.32-6.12,3.06-11",
    style: {
      fill: "#5e8c89"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3978",
    d: "M131.87,254c0-.12-.12-.24-.12-.36a.44.44,0,0,0,.12.36m3.89-6.93a6.36,6.36,0,0,0-2.67-5.47,6.36,6.36,0,0,1,2.67,5.47m-2.92-6.56h0a4.93,4.93,0,0,0,1-2.92v0a5.22,5.22,0,0,1-1,2.92h0m-20.9-19.57h0",
    style: {
      fill: "#dfe8e8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3982",
    d: "M144.57,265.77h-5.85c.24-3-7.07-6.46-8.66-12.44a.76.76,0,0,1,.12-.49c2.69-3.41,5.37-7.56.86-11.58v-.37c2.07-2.56-.37-5.12-1.71-6.83s9.39-4.51,3.41-7.8c-5.49-3-18.66-5.13-20.49-5.37H112c.36,0,7.8.12,17.56.12h7.08a1,1,0,0,0-.49.73c0,.25.12.37.24.61a6.3,6.3,0,0,1,2.2,4.76v.73a6.52,6.52,0,0,1-5,5.37.76.76,0,0,0-.61.73.75.75,0,0,0,.12.49,5.19,5.19,0,0,1,1,2.92v.25a4.72,4.72,0,0,1-1,2.93h0a.79.79,0,0,0,.24,1.09h0a6.7,6.7,0,0,1,2.69,5.49h0v.25c-.13,2.68-1.59,5-3.54,5.73a.66.66,0,0,0-.49.73.47.47,0,0,0,.12.37h0a7.32,7.32,0,0,0,6.47,3.9h0c3.29,0,6.22,2.32,6.46,5.37v.61a7.38,7.38,0,0,0-.49,1.7",
    style: {
      fill: "#527f7c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3986",
    d: "M136.38,221c.12,0,.24-.12.37-.12h8.18a5.69,5.69,0,0,0,5.63-5.62,5.69,5.69,0,0,1-5.63,5.62h-8.18l-.37.12h0m-32.88-.12h0m0,0h0",
    style: {
      fill: "#eff3f3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3990",
    d: "M144.81,220.84H103.38a5.2,5.2,0,0,1-3.3-1.22c1.83.12,4,.12,6.47.12,16,0,41.56-2,41.2-9.9a7.8,7.8,0,0,1,2.68,5.38,5.6,5.6,0,0,1-5.62,5.62",
    style: {
      fill: "#588683"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3994",
    d: "M111.73,220.88h0",
    style: {
      fill: "#d0dddc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3998",
    d: "M129.26,220.94c-9.73,0-17.15-.13-17.51-.13h24.92a.42.42,0,0,0-.36.13h-7.05",
    style: {
      fill: "#4d7976"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4002",
    d: "M108.73,265.7H106c-1.21-2.17.48-6.27,9.29-6.51h0a.72.72,0,0,1,.12,1.44c-4.34,1.33-5.79,3.62-6.64,5.07",
    style: {
      fill: "#6e9895"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4006",
    d: "M121.64,212.73h-2.19a178.47,178.47,0,0,1-18.13-1c5.35-.48,10.83-.61,16.18-.61h2a181.36,181.36,0,0,1,18.12,1c-5.23.48-10.58.6-15.93.6",
    style: {
      fill: "#749b99"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4010",
    d: "M766.29,186.25c0-12.05-3-27.25-11-39.45s-21.23-21.38-41.71-21.38a85.79,85.79,0,0,0-18.52,2.26l.15.9a84,84,0,0,1,18.37-2.26c20,0,33,9,41,20.93,8,12.05,10.84,27.1,10.84,39h.9",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4014",
    d: "M750.58,148.49c10.22.46,10.52-7.21,7.66-11-4.06-5.71-11.42-5.56-14.58,1.65-2.4,5.57,1.05,9,6.92,9.32",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4018",
    d: "M714.13,125.9c-6.54.3-12.63,17.24-1.49,20.36,11.15,3,9.51-20.81,1.49-20.36",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4022",
    d: "M714.1,125.82c6.83.59-4.75-19.16-5.2-22.57-.3-3.42-12.18,21.23,5.2,22.57",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4026",
    d: "M739.93,134.62c4.79-5.23-4.18-19.44-13.16-17.2-9.12,2.39,6.58,24.38,13.16,17.2",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4030",
    d: "M740.06,132.83c-.75-7-15.39-4.18-16.14,5.23-.59,9.41,17.19,4.48,16.14-5.23",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4034",
    d: "M754.59,146.2c-5.41-8.72-20,5.26-18.19,8.57s23.75.3,18.19-8.57",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4038",
    d: "M684.87,120.88c-1.92,4.73,7.68,17.73,17.14,6.21,2.36-2.81-15.81-9.46-17.14-6.21",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4042",
    d: "M767.34,176.85c-1.05-12.2-6.78-31-12.2-50.61s-10.69-40.21-10.69-56V67.65h-.91v2.56c0,16,5.28,36.45,10.7,56.18s11.14,38.41,12.2,50.46h.9",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4046",
    d: "M745.59,86.5c10.21-.15,10.06-7.8,7.06-11.4-4.5-5.4-11.86-4.95-14.56,2.55-2,5.55,1.65,8.85,7.5,8.85",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4050",
    d: "M761.41,151.87c6.93-.76,7.38-8.29,5.57-11.76-2.71-5.12-7.68-4.07-9.94,3.32-2,5.87.3,8.89,4.37,8.44",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4054",
    d: "M736.11,67.73c-5.85,3-4.35,21,7,19s0-22.8-7-19",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4058",
    d: "M756,130.62c3.76,5.57,10.69-15.21,10.84-18.67.3-3.47-20.63,4.21-10.84,18.67",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4062",
    d: "M743.74,68.41c5.69,3.75,5.24-19,6.44-22.18,1.35-3.15-21,12.59-6.44,22.18",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4066",
    d: "M747,95.94c-1.8-10-20.52-2.54-20.07,1.2s22,9.14,20.07-1.2",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4070",
    d: "M757.16,131c4.06-9.32-15.64-13.53-17.29-10.22S752.8,140.62,757.16,131",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4074",
    d: "M763,87.84c-2.55-4.52-18.51-5.27-15.65,9.33.6,3.61,17.31-6.17,15.65-9.33",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4078",
    d: "M751.73,115.66c9.77-2.7,7.82-10.07,4.06-12.77-5.72-4.21-12.63-1.81-13.38,6-.75,6,3.61,8.27,9.32,6.76",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4082",
    d: "M772.37,200.5c1.22-15,6.88-43.33,14.39-67.67,3.82-12.25,8.11-23.58,12.4-31.69a40.24,40.24,0,0,1,6.58-9.64c2.3-2.3,4.44-3.52,6.43-3.52a7.94,7.94,0,0,1,1.84.3,3.74,3.74,0,0,1,1.22,1.38,26.45,26.45,0,0,1,2.14,6.28c.92,4,1.69,8.57,2.15,12.24.15,1.84.46,3.37.46,4.6a14.6,14.6,0,0,1,.15,1.83l.92-.15a126,126,0,0,0-1.69-12.71c-.61-3.21-1.22-6.58-2-9.18A25.3,25.3,0,0,0,816,89.2a4,4,0,0,0-1.69-1.84,5.29,5.29,0,0,0-2.14-.3c-2.45,0-4.75,1.37-7.2,3.82-4,4.14-8,11.49-11.78,20.37-11.18,26.94-20.36,69.5-22.05,89.25h1.23",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4086",
    d: "M819.69,111.06c-5.38,1.38-5.07,21.2,4.45,19.05s.31-20.28-4.45-19.05",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4090",
    d: "M788.77,124.67c-1.37-6.22-15.64-4.4-14.58-.6,3.65,13.66,19,20.49,14.58.6",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4094",
    d: "M795.19,122.31c7.77.61,11.74,18.6-5.94,16.62s.76-17.07,5.94-16.62",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4098",
    d: "M793.09,116.49c10.53-2.75,18.16-6.41,10.53-10.38s-20,2.75-16.18,6.72c3.82,4.12,5.65,3.66,5.65,3.66",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4102",
    d: "M788.6,115.93c-8.07-8.68-12.78-16.44-3.5-15.52s16.59,14,10.8,15.52-7.3,0-7.3,0",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4106",
    d: "M801.46,96.18c10.07-2.14,2-20.61-1.68-20-3.66.46-8.55,22.14,1.68,20",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4110",
    d: "M816.87,100.35c1.84-4.9-7.8-17.6-17.28-6-2.3,2.75,15.91,9.33,17.28,6",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4114",
    d: "M779.07,154.6c10.16,1.37,11.07-6.21,8.65-10.31-3.64-6.07-10.92-6.52-14.71.3-2.89,5.46.3,9.26,6.06,10",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4118",
    d: "M811.86,87.53c-4-6.9,12.57-12,13.18-1.08S814.46,92,811.86,87.53",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4122",
    d: "M819.29,100.73c-5-6.13-19,11.49-12.41,15.78s17.32-9.65,12.41-15.78",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4126",
    d: "M818.76,99.3c-3.85,10.16,12.77,11.54,16.31,5.23,3.39-6.15-13.08-13.85-16.31-5.23",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4130",
    d: "M762,190.93c7.85-24.61,14.5-77.63,14.5-119.92,0-16.76-1.06-31.86-3.48-42.74-1.2-5.44-2.86-10-4.83-13s-4.53-4.83-7.55-4.83a9.84,9.84,0,0,0-5,1.51l.45.76a9.57,9.57,0,0,1,4.53-1.36c2.57,0,4.83,1.51,6.8,4.53,2.87,4.38,5,11.93,6.34,21.59a246.85,246.85,0,0,1,2,33.69c0,42.13-6.79,95.3-14.5,119.76H762",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4134",
    d: "M753.15.24c-3.92,3.32-1.35,19.29,12.36,13.41C769,12.3,755.86-2,753.15.24",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4138",
    d: "M778.78,55.56c9-6.38,14.57-12.6,6.07-13.51s-17.61,9.72-12.6,12.14,6.53,1.37,6.53,1.37",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4142",
    d: "M774.44,56.56c-10.6-5.15-17.87-10.75-8.94-13.17,8.94-2.58,20.6,7.12,15.6,10.6-4.69,3.48-6.66,2.57-6.66,2.57",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4146",
    d: "M780,106.29c7.44-8.05,11.53-13.51,2.88-12.6s-15.32,13.2-9.86,14.57c5.31,1.36,7-2,7-2",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4150",
    d: "M771.56,108.4c-7.88-8.78-12.57-16.66-3.34-15.6s16.36,14.24,10.6,15.75-7.26-.15-7.26-.15",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4154",
    d: "M776.93,33.7c5.29-4.39-10.59-18-15-12.25s6.66,18.91,15,12.25",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4158",
    d: "M774.42,133.41c6.81,0,3.48-20.57-3.63-18.91-7,1.67-6.81,18.91,3.63,18.91",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4162",
    d: "M773.58,35.28c6.21,2.88,11.81-17.26,4.69-18.78S764,30.74,773.58,35.28",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4166",
    d: "M774,83c-10.14-.15-10.14-7.72-7.12-11.5,4.39-5.45,11.81-5,14.53,2.42C783.53,79.78,779.9,83,774,83",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4170",
    d: "M783.52,64.13c5.91,3,4.4,20.92-7,19.11s-.15-22.75,7-19.11",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4174",
    d: "M779.58,116.49c5.91,3,4.4,21-7,19.08s-.15-22.72,7-19.08",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4178",
    d: "M771.61,154.56c10-2.12,3.18-12.86-.45-12.25-8.32,1.36-10,14.37.45,12.25",
    style: {
      fill: "#3b3f3e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4182",
    d: "M783.55,159.73h-.16a4,4,0,0,0,.16-1.37c0-2-1.07-3.51-2.44-3.51H759c-1.37,0-2.28,1.38-2.44,3.21a4.47,4.47,0,0,0,.16,1.52h-.31c-22.42,8.09-4.73,103.71-2.29,105.23s29,1.83,31.27.76c2.44-.91,23.18-99.12-1.83-105.84",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4186",
    d: "M793.65,225.7v-.3h0v.3",
    style: {
      fill: "#f9fafc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4190",
    d: "M775,227.13c-6.06,0-12.57-.3-18.48-.91v-.91a159.76,159.76,0,0,0,19.24,1.06c3.63,0,7-.15,10-.3,0,.3-.15.46-.15.76-3,.3-6.81.3-10.6.3M751,225.31c-1.52-.3-2.88-.6-4.09-.9a1.92,1.92,0,0,0-.15-.91c1.36.3,2.72.75,4.09.91a1.9,1.9,0,0,1,.15.9",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4194",
    d: "M779.72,168.65c-6.8-.15-13.46-.6-19.5-1.06-.15-.3-.15-.6-.31-.75,5.75.45,12.25.91,18.9,1.06a4,4,0,0,1,.91.75M755.08,167a44.16,44.16,0,0,1-5.14-.76c.15-.3.3-.45.45-.75,1.66.3,3.48.45,5.44.75l-.75.76",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4198",
    d: "M795.65,202.81v0h0",
    style: {
      fill: "#f9fafc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4202",
    d: "M745.72,208.46v-.91c.9,0,2-.15,3-.15a4.21,4.21,0,0,0,1.36-.15v.91a4.21,4.21,0,0,0-1.36.15,19.45,19.45,0,0,0-3,.15m11.36-.91v-.91c9.86-.76,21.68-1.67,31.08-3.33v.91c-8.64,1.51-19.71,2.57-31.08,3.33",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4206",
    d: "M795,212.93h0",
    style: {
      fill: "#f9fafc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4210",
    d: "M746.5,220a2,2,0,0,0-.15-.91,38.66,38.66,0,0,0,4.09-.15v.91a34.6,34.6,0,0,1-3.94.15m10.15-.3v-.91c9.7-.45,21.52-1.36,30.61-3.49a1.14,1.14,0,0,1-.15.76c-9.09,2.28-20.76,3.18-30.46,3.64",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4214",
    d: "M748.24,194.25h-2.88v-.76h4.7v.76h-1.82m10-.15a1.82,1.82,0,0,1,.16-.91c9.54-.31,20.46-1.22,29.86-2.43v.91a280,280,0,0,1-30,2.43",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4218",
    d: "M748.29,177.59h-1.67a6.75,6.75,0,0,1,.15-.76h4.85c0,.31-.16.61-.16.91a24.72,24.72,0,0,0-3.17-.15m12.11-.3a1.92,1.92,0,0,1,.15-.91c4.84-.3,10.14-.76,15.44-1.21l7.72-.91a3.62,3.62,0,0,0,.45.76q-3.85.45-8.17.9c-5.45.61-10.75,1.06-15.59,1.37",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4222",
    d: "M790.17,247.24a1.83,1.83,0,0,0,.16-.91h0c0,.3-.16.61-.16.91h0m-40.49-2.43h0",
    style: {
      fill: "#f9fafc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4226",
    d: "M778.39,248.61a141.82,141.82,0,0,1-21.63-2v-.9a163.2,163.2,0,0,0,21.63,2H781c-.15.3-.15.61-.3.91h-2.27m-24.8-2.42c-1.36-.15-2.57-.45-3.78-.61a6.5,6.5,0,0,0-.15-.75h0c1.05.15,2.42.45,3.78.6a6.75,6.75,0,0,1,.15.76",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4230",
    d: "M760.9,212.74h-4.09v-.91h3.79c9.09,0,19.09-.75,27-1.51a2,2,0,0,1-.15.91c-7.57.75-17.43,1.51-26.52,1.51m-10.61-.45a38.71,38.71,0,0,1-4.39-.61v-.91c1.36.15,2.88.46,4.39.61a1,1,0,0,0,0,.91",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4234",
    d: "M795.66,200.14v0",
    style: {
      fill: "#f9fafc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4238",
    d: "M780.78,201a195.31,195.31,0,0,1-23-1.21,1.94,1.94,0,0,1,.15-.91c3.18.3,6.52.61,10.31.76,4.54.3,8.94.3,13.18.3,2.43,0,4.85,0,7.13-.15v.76a44.63,44.63,0,0,1-7.73.45m-30.93-2.12c-1.66-.3-3.18-.61-4.54-.76v-.91c1.36.31,2.88.61,4.54.91v.76",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4242",
    d: "M787.66,186.2c-8.94-.15-19.1-.76-28.19-1.82a6.75,6.75,0,0,1,.15-.76c3.79.46,7.88.76,12.28,1.06,5.3.3,10.61.61,15.61.76a1.14,1.14,0,0,1,.15.76m-37-3.19c-1.67-.3-3.18-.6-4.7-.9a6.31,6.31,0,0,1,.15-.76c1.37.3,3,.6,4.55.91V183",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4246",
    d: "M790.87,243.86h0",
    style: {
      fill: "#f9fafc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4250",
    d: "M781.82,244.72c-3.93-.15-8.32-.45-12.71-1.06a98.1,98.1,0,0,1-12.55-2.27v-.9a114.08,114.08,0,0,0,12.55,2.27c4.39.6,8.93.9,12.86,1.05a1.92,1.92,0,0,1-.15.91m-29.2-4.38a30.54,30.54,0,0,1-3.93-1.52c0-.3-.15-.6-.15-.91,1.21.46,2.42,1.06,3.93,1.52a1.92,1.92,0,0,1,.15.91",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4254",
    d: "M793.17,229.26v0h0",
    style: {
      fill: "#f9fafc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4258",
    d: "M748.23,234.59c0-.3-.15-.6-.15-.91,1.36,0,2.57-.15,3.78-.15a1.92,1.92,0,0,0,.15.91,33.14,33.14,0,0,1-3.78.15m8.33-.3v-.91c13.17-.76,22.41-1.66,28.62-2.88,0,.31-.16.61-.16.91a237,237,0,0,1-28.46,2.88",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4262",
    d: "M753,261.67a.52.52,0,0,0-.15-.3h0c.15,0,.15.15.15.3m34.1-.76c.15-.3.15-.75.3-1.06h0a2.78,2.78,0,0,1-.3,1.06",
    style: {
      fill: "#f9fafc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4266",
    d: "M761.33,263.16c-3-.3-5.87-.6-8.12-1.05,0-.15-.15-.3-.15-.45a.52.52,0,0,0-.15-.3,86.57,86.57,0,0,0,10.38,1.2,9.79,9.79,0,0,0-2,.6",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4270",
    d: "M787.76,258.63a1.9,1.9,0,0,0,.15-.9h0c0,.3-.15.6-.15.9h0",
    style: {
      fill: "#f9fafc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4274",
    d: "M775.14,257.53a93.71,93.71,0,0,1-18.27-5v-.91a88.14,88.14,0,0,0,10.72,3.47c2.87.76,5.89,1.36,8.61,1.82-.16.15-.31.3-.46.3a1.14,1.14,0,0,0-.6.3m-20.54-5.89c-1.51-.75-2.87-1.36-4.08-2.11,0-.31-.15-.76-.15-1.06,1.21.75,2.57,1.51,4.08,2.26,0,.16.15.61.15.91",
    style: {
      fill: "#e37e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4278",
    d: "M769.23,158.06c-1.81,0-3.63-.15-5.44-.3a30,30,0,0,1-5.29-.76c1.81.15,3.63.15,5.29.15h13.3a16.67,16.67,0,0,0,2.73-.15,20.22,20.22,0,0,1-5.3.91c-1.66,0-3.47,0-5.29.15",
    style: {
      fill: "#e26560"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4282",
    d: "M785.31,265.75h0c.15,0,.15,0,.3-.15.31-.15.91-1.82,1.67-4.69h0c-.76,2.87-1.36,4.54-1.67,4.69a.52.52,0,0,0-.3.15m-1.67-107.58h0m0,0h0m0,0h0m0-.15h0m0,0h0m0,0h0",
    style: {
      fill: "#f9dcda"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4286",
    d: "M785.28,265.8H759.61a47.75,47.75,0,0,1-4.86-.61c1.82-.45,4.1-1.21,6.53-2,2.73.15,5.77.3,8.66.3,6.53,0,12.91-.61,17.17-2.58h0c-.76,2.89-1.37,4.56-1.68,4.71l-.15.15m-15.49-3.19c-2.13,0-4.26-.15-6.38-.15a66.38,66.38,0,0,0,11.69-4.86A61.31,61.31,0,0,0,786,258.66h1.67c-.15.46-.15.91-.3,1.37-3.95,1.82-10.79,2.58-17.62,2.58m16.4-4.86a65.6,65.6,0,0,1-10-.91c1.52-1.37,3-4.26,4.4-8.21a41.59,41.59,0,0,0,9.42-1.21c-.76,4-1.52,7.6-2.13,10.48a5.73,5.73,0,0,0-1.67-.15m-5.16-10c.3-.91.61-2,.91-2.88h3.8a49.35,49.35,0,0,0,5-.16c0-.3.15-.6.15-.91-.15.91-.3,1.67-.45,2.59a42.5,42.5,0,0,1-9.42,1.36m4.71-3.8h-3.5c1.07-3.79,2-8,2.89-12.45a52.49,52.49,0,0,0,8.2-2.13c-.76,5.17-1.52,10.18-2.28,14.58h-5.31m-.61-13.36c.15-1.22.46-2.43.61-3.65,3-.15,5.77-.46,7.75-.61v-.45c-.16,1.06-.31,2-.46,3v-.45a58.36,58.36,0,0,1-7.9,2.13m.76-4.41c.46-3.19.91-6.53,1.37-9.87a45.82,45.82,0,0,0,7.74-2.44,1.85,1.85,0,0,1,.16-.91c-.31,4.26-.76,8.36-1.37,12.46-2.28.3-4.86.61-7.9.76m1.37-10.79c.15-1.36.3-2.88.45-4.25,2.89-.3,5.32-.61,7.45-.91v-.91c-2.13.3-4.71.6-7.45.91l.46-6.08c2.73-.45,5.16-.91,7.44-1.52-.15,3.34-.3,6.84-.6,10.18a28.71,28.71,0,0,1-7.75,2.58m.91-11.85c0-.91.15-1.82.15-2.58,2.73-.15,5.17-.3,7.29-.45v-.31a13.23,13.23,0,0,1-.15,2.43V202c-2,.46-4.56,1.07-7.29,1.52m.15-3.49a77.58,77.58,0,0,0,0-8.36c2.58-.3,5-.76,7.44-1.21v-.91c-2.27.45-4.86.76-7.44,1.21-.15-1.67-.3-3.19-.46-4.71h7.75v-.91h-7.9A36.43,36.43,0,0,0,784.22,175c3.34-.45,6.53-.91,9.57-1.36,0-.31-.15-.61-.15-.92-3.19.61-6.54,1.07-9.73,1.37a26.53,26.53,0,0,0-4.1-5.62c3.5.15,7,.15,10.48.15h2c-.15-.3-.15-.61-.3-.76h-2c-3.64,0-7.29,0-10.94-.15a24.42,24.42,0,0,0-13.82-7.14h.3c4.41,0,16.87-2.73,17-5.16a3.66,3.66,0,0,1,1.06,2.58h0c0,.45-.15.91-.15,1.37h.15c9.12,2.43,12.15,17.31,12.15,35.24,0,1.67,0,3.34-.15,4.86v-.3a33.81,33.81,0,0,1-7.29.91",
    style: {
      fill: "#db423c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4290",
    d: "M785.76,226.91c0-.3.15-.45.15-.76,3-.15,5.77-.45,7.74-.6v.3a.58.58,0,0,1-.15.46c-2.13.15-4.71.45-7.74.6",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4294",
    d: "M790.05,168.74c-3.49,0-7,0-10.47-.15-.3-.31-.45-.61-.76-.76,3.65.15,7.29.15,10.93.15h2a2.39,2.39,0,0,1,.31.76h-2",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4298",
    d: "M788.12,204.35v-.91c2.74-.45,5.17-.91,7.44-1.52v.91c-2.12.46-4.7,1.07-7.44,1.52",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4302",
    d: "M787.21,216.27a1.17,1.17,0,0,1,.15-.76,45.07,45.07,0,0,0,7.75-2.43h0a2,2,0,0,1-.15.92,69.43,69.43,0,0,1-7.75,2.27",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4306",
    d: "M788.37,191.78v-.91c2.59-.3,5.17-.76,7.45-1.22v.92c-2.43.45-4.86.75-7.45,1.21",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4310",
    d: "M784.1,175.05a3,3,0,0,0-.46-.76c3.19-.46,6.53-.91,9.72-1.37a2,2,0,0,1,.15.91c-2.73.31-5.92.76-9.41,1.22",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4314",
    d: "M780.77,248.6c.15-.3.15-.6.3-.9a41.55,41.55,0,0,0,9.41-1.37c0,.3-.15.61-.15.91a45.21,45.21,0,0,1-9.56,1.36",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4318",
    d: "M787.64,211.27a2,2,0,0,1,.15-.92c2.89-.3,5.32-.6,7.45-.91v.91c-2.13.16-4.71.46-7.6.92",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4322",
    d: "M788.37,200.74V200q4.11-.22,7.3-.45v.91c-2.13.15-4.71.3-7.3.3",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4326",
    d: "M793.09,186.2h-5.32c0-.3-.15-.6-.15-.91h7.9v.91h-2.43",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4330",
    d: "M785.72,244.77h-3.8a2,2,0,0,0,.15-.91h3.65c1.82,0,3.64,0,5.15-.15h0c0,.3-.15.6-.15.91-1.52.15-3.18.15-5,.15",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4334",
    d: "M784.89,231.41c0-.3.15-.6.15-.91a41.22,41.22,0,0,0,8.2-2.12v.91a50,50,0,0,1-8.35,2.12",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4338",
    d: "M770,263.49c-3,0-5.91-.15-8.63-.3.6-.15,1.36-.46,2-.61,2.12.15,4.24.15,6.36.15,6.82,0,13.64-.75,17.73-2.88-.15.31-.15.76-.3,1.06h0c-4.09,2-10.61,2.58-17.13,2.58",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4342",
    d: "M786.09,258.63a79,79,0,0,1-10.91-1.06,1.14,1.14,0,0,1,.6-.3c.15-.15.31-.3.46-.3a66.66,66.66,0,0,0,10,.91h1.82c0,.3-.15.6-.15.91a7.6,7.6,0,0,0-1.82-.16",
    style: {
      fill: "#dd6c68"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4346",
    d: "M756.54,255.94c-.6,0-1.2-1.65-1.8-4.36l2.25.9a13.22,13.22,0,0,1-.15,3.31l-.3.15m.3-4.21c-.9-.3-1.65-.75-2.4-1-.3-1.35-.61-2.71-.91-4.36l3.16.45c.15,1.8.15,3.46.15,5m-.15-5.86c-1.2-.15-2.25-.3-3.31-.45-.3-1.5-.45-3.16-.75-5a41.1,41.1,0,0,0,4.06,1v4.36m0-5.26a26.43,26.43,0,0,1-4.06-1.2c-.15-1.51-.45-3.16-.6-4.81,1.5,0,3.16-.15,4.66-.3a44.24,44.24,0,0,0,0,6.31m-4.81-6.92c-.3-2.7-.6-5.41-.75-8.26,1.65.3,3.61.6,5.41.75v7.21c-1.5.15-3,.15-4.66.3m4.66-8.41c-1.95-.3-3.76-.45-5.56-.9-.15-1.51-.3-3-.3-4.51,2,0,3.91-.15,6-.15-.15,1.95-.15,3.75-.15,5.56m-6-6.17-.45-6.76c2.1.15,4.36.3,6.61.3-.15,2.11-.15,4.21-.15,6.16-2.1.15-4.06.3-6,.3m6.31-7.21c-2.4,0-4.66-.15-6.76-.3,0-1-.15-2.26-.15-3.31l7.06-.45a39.53,39.53,0,0,1-.15,4.06m-6.76-4.66c-.15-2.86-.15-5.71-.15-8.42,2.4.45,5.11.75,7.81,1.05-.15,2.26-.45,4.66-.45,6.92-2.7.15-5.11.3-7.21.45m7.66-8.27c-2.85-.3-5.41-.6-7.81-1.05v-3.61c2.55,0,5.41-.15,8.26-.15-.15,1.51-.3,3.16-.45,4.81m-7.81-5.56c.15-3.61.3-7.21.6-10.37,2.85.45,5.86.9,9,1.2-.3,2.26-.6,4.66-.91,7.07-.15.6-.15,1.2-.3,1.95-2.85.15-5.71.15-8.41.15m9.77-9.92c-3.31-.3-6.32-.75-9-1.2.15-1.65.45-3.16.6-4.66,2.86,0,5.86-.15,9-.3-.15,1.8-.3,3.91-.6,6.16m-8.27-6.76c.75-4.36,2-7.82,3.61-9.77l5.11.45a33,33,0,0,1,.15,8.87c-3,.3-6,.45-8.87.45M760,166.66c-1.36-.15-2.86-.3-4.06-.45a3.36,3.36,0,0,1,1.8-.91c.15,0,.45-.15.6-.15a2.59,2.59,0,0,1,1.66,1.51",
    style: {
      fill: "#e15952"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4350",
    d: "M756.55,226.22c-1.95-.3-3.75-.45-5.55-.9v-.9c1.65.3,3.6.6,5.55.9v.9",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4354",
    d: "M760.25,167.57l-5.11-.45.75-.75,4.06.45c.15.15.15.45.3.75",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4358",
    d: "M750,208.11v-.9l7.21-.45v.9l-7.21.45",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4362",
    d: "M750.72,220v-.9c1.95,0,3.9-.16,6-.16v.91c-2.25,0-4.2,0-6,.15",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4366",
    d: "M750,194.23v-.9c2.56,0,5.41-.15,8.42-.15a1.9,1.9,0,0,1-.15.9c-2.86.15-5.71.15-8.27.15",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4370",
    d: "M751.41,177.61c0-.3.15-.6.15-.9,2.86,0,5.72-.15,8.87-.3v.9c-3.31.15-6.31.3-9,.3",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4374",
    d: "M756.74,246.76c-1-.15-2.25-.3-3.16-.45,0-.3-.15-.6-.15-.9,1.05.15,2.11.3,3.31.45v.9",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4378",
    d: "M756.82,212.77c-2.4,0-4.5-.15-6.6-.3v-.91c2.1.15,4.35.3,6.75.3a1.92,1.92,0,0,1-.15.91",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4382",
    d: "M757.74,199.75c-2.7-.3-5.26-.6-7.81-1.05v-.9c2.4.45,5.11.75,8,1a2.23,2.23,0,0,0-.15.9",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4386",
    d: "M759.6,184.27c-3.16-.3-6.16-.75-9-1.2a1.12,1.12,0,0,1,.15-.75c2.71.45,5.71.9,9,1.2,0,.3-.15.45-.15.75",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4390",
    d: "M756.72,241.44c-1.35-.3-2.7-.75-3.9-1.05,0-.3-.15-.6-.15-.9,1.2.45,2.55.75,4.05,1.2v.75",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4394",
    d: "M751.93,234.49a1.9,1.9,0,0,0-.15-.9c1.65-.15,3.16-.15,4.66-.3v.9a40.1,40.1,0,0,1-4.51.3",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4398",
    d: "M756.9,252.53l-2.25-.9a1.94,1.94,0,0,1-.15-.91c.75.3,1.65.76,2.4,1.06v.75",
    style: {
      fill: "#e48682"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4402",
    d: "M461.06,221.24c-.72,0-1.3.14-1.3.43,1.88,5.07,24,34.47,53.44,41.27,22,5.22,67.48,2,75.16,0,28.52-7.24,51.7-31.42,52.85-41,0-.43-.87-.72-1.88-.72-7.67.29-37.07,1.44-85.44,1.44-50.54.15-85.59-1.15-92.83-1.44",
    style: {
      fill: "#5e8c89"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4406",
    d: "M462.15,225.84c.15.29.44.58.58.87,28.51,1.3,70.92,1.74,108,1.74,28.95,0,54.71-.29,68.32-.87l.43-.87c-29.09,1.16-125.77,1.45-177.3-.87",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4410",
    d: "M478.83,244.1a3.69,3.69,0,0,0,.87.72c18.15,1.87,43.22,3,67.85,3h3.75a666.72,666.72,0,0,0,72.75-3.61c.28-.28.72-.57,1-.86-46.39,5.62-110.79,4.47-146.23.72",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4414",
    d: "M551.26,259.12c18.76,0,36.51-.58,52.4-1.72l1.72-.86c-35.79,2.72-77.6,2.29-108.37.14a6.85,6.85,0,0,0,1.43.72c14.89,1,32.06,1.57,49.1,1.57a30.86,30.86,0,0,0,3.72.15",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4418",
    d: "M609.37,250.89a15.09,15.09,0,0,0-5.45-1,9.45,9.45,0,0,0-4.45,1.86,7.12,7.12,0,0,1-3.45,1.44,12.53,12.53,0,0,1-4-1,17,17,0,0,0-5.31-1.29,10.44,10.44,0,0,0-4.74,1.72,9.35,9.35,0,0,1-3.59,1.44,12.75,12.75,0,0,1-3.87-1.15,10.91,10.91,0,0,0-5.17-1.29c-1.87,0-3.3.86-4.88,1.58a8.35,8.35,0,0,1-3.59,1.29,10,10,0,0,1-3.73-1.15,12,12,0,0,0-5-1.43h0a12,12,0,0,0-5,1.43,10.39,10.39,0,0,1-3.73,1.29h0a10.5,10.5,0,0,1-3.74-1.29c-1.57-.72-3-1.58-4.88-1.58a12.59,12.59,0,0,0-5.16,1.44,11.11,11.11,0,0,1-3.74,1.15,7.57,7.57,0,0,1-3.59-1.44,10.84,10.84,0,0,0-4.73-1.58,13.86,13.86,0,0,0-5.31,1.29,11.54,11.54,0,0,1-3.88,1.15,7.65,7.65,0,0,1-3.59-1.43,9.87,9.87,0,0,0-4.59-1.73,14.48,14.48,0,0,0-5.46,1.15,11.74,11.74,0,0,1-3.87,1c-.29,0-.58-.15-.86-.15.57.43,1.14.72,1.72,1.15a13.54,13.54,0,0,0,4.16-1.15,9.74,9.74,0,0,1,4.16-1,7.33,7.33,0,0,1,3.31,1.43,8.94,8.94,0,0,0,4.73,1.73,10.64,10.64,0,0,0,5.17-1.3,12.42,12.42,0,0,1,4-1.14,9.2,9.2,0,0,1,3.45,1.29,11,11,0,0,0,4.88,1.72,13.38,13.38,0,0,0,5.16-1.43,10.69,10.69,0,0,1,3.88-1.15,10.83,10.83,0,0,1,3.59,1.29,12.12,12.12,0,0,0,5,1.58h0a12,12,0,0,0,5-1.44A11.61,11.61,0,0,1,552,252.9a10.84,10.84,0,0,1,3.73,1.15,12.58,12.58,0,0,0,5.17,1.43,11,11,0,0,0,4.88-1.57,10.8,10.8,0,0,1,3.59-1.3,12.88,12.88,0,0,1,3.88,1.15,11.46,11.46,0,0,0,5.31,1.29c1.86,0,3.3-.86,4.88-1.72a9.72,9.72,0,0,1,3.44-1.43,11.81,11.81,0,0,1,4,1,11.86,11.86,0,0,0,5.31,1.15,9.43,9.43,0,0,0,4.6-1.87,7.19,7.19,0,0,1,3.3-1.43c1.15-.15,2.58.43,4.16.86a20.38,20.38,0,0,0,4,1,8.84,8.84,0,0,0,1.58-1,.53.53,0,0,0-.43.14,9.22,9.22,0,0,1-4-.86",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4422",
    d: "M491.6,234.79c1.38,1.93-.14,3.87-3.31,4.42s-6.76-.55-8.14-2.35.14-3.86,3.31-4.41,6.76.41,8.14,2.34",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4426",
    d: "M488.5,235.3c.55.83,0,1.66-1.51,1.93a4.2,4.2,0,0,1-3.72-1.1c-.55-.83,0-1.65,1.51-1.93a4.26,4.26,0,0,1,3.72,1.1",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4430",
    d: "M609.55,234.7c-1.29,1.88.15,3.89,3.32,4.32s6.76-.57,8.2-2.44c1.29-1.88-.14-3.89-3.31-4.32s-6.91.57-8.21,2.44",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4434",
    d: "M612.34,235.24c-.72,1,0,1.87,1.58,2.16a4.88,4.88,0,0,0,4.17-1.16c.72-1,0-1.86-1.59-2.15a4,4,0,0,0-4.16,1.15",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4438",
    d: "M522.72,237c.14,2-2.37,3.62-5.71,3.76s-6.28-1.39-6.42-3.48,2.37-3.63,5.58-3.77c3.48,0,6.27,1.54,6.55,3.49",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4442",
    d: "M519.76,237.22c.14.84-1.25,1.53-2.93,1.53s-3.06-.55-3.2-1.39,1.26-1.53,2.93-1.53,3.2.69,3.2,1.39",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4446",
    d: "M556.57,237.63c.14,2-2.39,3.66-5.64,3.81s-6.2-1.41-6.34-3.39,2.26-3.66,5.64-3.66,6.06,1.27,6.34,3.24",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4450",
    d: "M553.42,237.77c.14,1-1.13,1.83-2.68,1.83s-3-.7-3.1-1.69,1.13-1.69,2.68-1.83,2.95.71,3.1,1.69",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4454",
    d: "M590.8,237.82c-1,2-4.42,3.13-7.56,2.71s-5-2.28-4.13-4.14,4.42-3.13,7.56-2.85c3.27.43,5.13,2.42,4.13,4.28",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4458",
    d: "M587.18,237.43a2.88,2.88,0,0,1-3,1c-1.28-.14-2-.85-1.56-1.57a2.78,2.78,0,0,1,2.85-1c1.42,0,2.13.71,1.7,1.56",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4462",
    d: "M636,232.1h0m.15-.15h0m0,0h0m0,0c3-3.91,4.77-7.38,5.06-9.85,0-.28-.72-.72-1.73-.72h-.15a12.06,12.06,0,0,0-2.17.15h0a11.36,11.36,0,0,0,2.32-.15h.14c.87,0,1.59.29,1.59.58-.14,2.46-2,5.94-5.06,10",
    style: {
      fill: "#cedcdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4466",
    d: "M553.89,265.69H540.71c-10.28-.29-20.13-1-27.51-2.75h0c-.58-.14-1-.29-1.6-.43-.14,0-.29-.15-.43-.15a7.15,7.15,0,0,1-1-.29c-.15,0-.29-.14-.58-.14-.29-.15-.73-.15-1-.29-.14,0-.29-.15-.43-.15-.44-.14-.73-.29-1.16-.43-.14,0-.29-.14-.43-.14l-1.31-.44h-.14c-1.6-.58-3-1.3-4.64-2,5.51.29,11.44.44,17.67.44,3.33,0,6.66,0,10-.15,6.37.15,12.89.29,19.26.29h3.77c18.82,0,36.49-.58,52.42-1.74l1.74-.86c-17.52,1.3-36.35,1.88-54.74,1.88-4.06,0-8,0-11.88-.15,4.93-.29,9.85-.72,14.92-1.3a170.94,170.94,0,0,0,19.55-3.48c.15,0,.15,0,.29.15a12.57,12.57,0,0,0,5.07,1.3h.29a9.2,9.2,0,0,0,4.78-1.73,9.73,9.73,0,0,1,3.47-1.45h.15a17.63,17.63,0,0,1,3.91,1,15.19,15.19,0,0,0,4.92,1.16h.44a9.55,9.55,0,0,0,4.63-1.88,6.16,6.16,0,0,1,3.33-1.45h.29a15.93,15.93,0,0,1,3.91.87,20.69,20.69,0,0,0,4,1,10.09,10.09,0,0,0,1.6-1,.56.56,0,0,0-.44.14h-.29a13.66,13.66,0,0,1-3.76-.87,14.91,14.91,0,0,0-4.93-1h-.57a9.52,9.52,0,0,0-4.49,1.88,7.27,7.27,0,0,1-3.33,1.45h-.15a14.84,14.84,0,0,1-3.76-1,15.28,15.28,0,0,0-5.07-1.16h-.29a9.38,9.38,0,0,0-4.64,1.74,9.88,9.88,0,0,1-3.47,1.44h-.15a9.16,9.16,0,0,1-3.47-1,154.26,154.26,0,0,0,19.11-6.23c10.72-.58,20.86-1.44,30-2.46.29-.29.72-.58,1-.87-9,1-18.68,1.89-28.82,2.46a149,149,0,0,0,15.36-7.24,4,4,0,0,0,1.3.29,6.83,6.83,0,0,0,1.74.15c2.6,0,5.35-1,6.51-2.61a2.28,2.28,0,0,0-.43-3.18c2.89-1.89,5.65-3.77,8.25-5.65,3.91-.15,7.39-.15,10.28-.29l.44-.87c-2.61.14-5.94.14-9.56.29,2.46-1.88,4.64-3.62,6.81-5.5a1.44,1.44,0,0,1,.43-.15,9.84,9.84,0,0,0,2.17-.14h.15c1,0,1.74.29,1.74.72-.29,2.46-2.18,5.94-5.07,9.85h0c-8.55,11.15-26.65,25.63-47.65,31h0c-4.92,1.59-19.4,2.89-35.33,3.18",
    style: {
      fill: "#4c7976"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4470",
    d: "M628.74,227.87c.44-.29.72-.58,1.16-.87,3.76-.15,7-.15,9.55-.29l-.43.87c-2.9.14-6.37.29-10.28.29",
    style: {
      fill: "#c54b40"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4474",
    d: "M594.08,246.84l2.16-.87c10.09-.57,19.74-1.44,28.81-2.45-.28.29-.72.58-1,.87-9.22,1-19.31,1.87-30,2.45",
    style: {
      fill: "#c5b8a1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4478",
    d: "M551.26,259.12h-3.72c-6.44,0-12.88-.15-19.33-.29l10.6-.43c3.86,0,7.87.14,11.88.14,18.32,0,37.22-.57,54.69-1.86l-1.72.86c-15.89,1-33.64,1.58-52.4,1.58",
    style: {
      fill: "#c5b8a1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4482",
    d: "M578.36,254.91a15.37,15.37,0,0,1-5-1.29c-.14,0-.14,0-.29-.15.58-.14,1.15-.28,1.87-.43a9,9,0,0,0,3.44,1h.15a8.21,8.21,0,0,0,3.59-1.44,10.4,10.4,0,0,1,4.73-1.72h.29a12.41,12.41,0,0,1,5,1.29,10.21,10.21,0,0,0,3.87,1h.14c1.15,0,2.3-.86,3.45-1.44a9.49,9.49,0,0,1,4.45-1.86h.57a16,16,0,0,1,5,1.14,14.73,14.73,0,0,0,3.87.87h.29a.51.51,0,0,0,.43-.15c-.57.29-1,.72-1.58,1a21.33,21.33,0,0,1-4-1,17.14,17.14,0,0,0-3.87-1h-.29a12.88,12.88,0,0,0-3.3,1.43,9.44,9.44,0,0,1-4.59,1.87h-.44a11.89,11.89,0,0,1-4.88-1.29,10.9,10.9,0,0,0-3.87-1h-.15a7.71,7.71,0,0,0-3.44,1.44,9.56,9.56,0,0,1-4.88,1.72h-.58",
    style: {
      fill: "#c54b40"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4486",
    d: "M614.46,239.28a6.68,6.68,0,0,1-1.72-.15c-.43-.14-.87-.14-1.3-.29.87-.43,1.73-.86,2.45-1.29h.86a4.64,4.64,0,0,0,3.31-1.3,1.4,1.4,0,0,0,.15-1.29c.72-.43,1.58-1,2.3-1.44a2.27,2.27,0,0,1,.43,3.17c-1.15,1.58-3.88,2.59-6.48,2.59",
    style: {
      fill: "#c5b8a1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4490",
    d: "M614.78,237.46h-.86c1.43-.86,2.87-1.58,4.16-2.44a1.36,1.36,0,0,1-.14,1.29c-.43.72-1.87,1.15-3.16,1.15",
    style: {
      fill: "#c54b40"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4494",
    d: "M315.66,239.81V217.74a1.71,1.71,0,0,0-1.68-1.68H194.53a1.7,1.7,0,0,0-1.68,1.68v22.07a1.71,1.71,0,0,0,1.68,1.69H314a1.72,1.72,0,0,0,1.68-1.69",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4498",
    d: "M212.77,216.12c.12,2.25.12,4.5.12,6.88,0,3.38-.12,6.88-.12,10v1.75c0,.63-.13,1.63-.13,2.75,0,.88-.12,2.38-.25,3.88H211c.13-1.25.13-2.63.25-4.13a22.42,22.42,0,0,0,.13-2.62v-1.76c.13-5.38.25-11.38,0-16.88h1.38",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4502",
    d: "M216.25,232.6v-.88c0-3.26-.13-6.52-.13-9.65,0-1.88-.12-3.88-.12-5.89h1.37c0,1.88.13,3.89.13,5.77.13,3.25.13,6.51.13,9.9v.75c0,4.39.12,7.14.25,9H216.5a62.79,62.79,0,0,1-.25-9",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4506",
    d: "M300.85,226.36c-.13,1.55-.26,3-.26,4.14-.13,1.93,0,4,0,6.07v5h-1.42v-5c0-2.07-.13-4.14,0-6.2,0-1.16.13-2.59.26-4.14.13-3.1.39-6.71.39-9.94h1.42v.9c0,2.84-.26,6.2-.39,9.17",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4510",
    d: "M306.43,233.23c0,2.72-.13,5.57-.13,8.41h-1.42c0-2.84.13-5.69.13-8.41.13-5.56.13-11.26.13-17.08h1.42v1.42c0,5.31-.13,10.48-.13,15.66",
    style: {
      fill: "#f3d5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4514",
    d: "M314.21,241.49H314a1.6,1.6,0,0,0,1.3-.65,1.07,1.07,0,0,1-1,.65m.78-24.92h0",
    style: {
      fill: "#f9dcda"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4518",
    d: "M313.85,241.5h-7.53c0-2.72.13-5.58.13-8.31a6.41,6.41,0,0,0,1.94-1.17c3-3.37,5.2-10,6.62-15.57l.13.12a2.4,2.4,0,0,1,.52,1.69v21.16a2.77,2.77,0,0,1-.39,1.56,2.72,2.72,0,0,1-1.42.52m-8.83,0H300.6v-6.62c1.82-.39,3.25-.78,4.55-1.17-.13,2.6-.13,5.2-.13,7.79m-5.72,0H223c25.44-.91,60-3.24,76.33-6.49v6.49",
    style: {
      fill: "#db423c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4522",
    d: "M300.67,241.48h-1.42V235c.52-.13.91-.13,1.42-.26v6.72h0",
    style: {
      fill: "#edb7a0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4526",
    d: "M306.32,241.54h-1.43c0-2.59.13-5.17.13-7.76a4.66,4.66,0,0,0,1.43-.52c0,2.72-.13,5.44-.13,8.28h0",
    style: {
      fill: "#edb7a0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4530",
    d: "M339.8,263.54V243.37a1.87,1.87,0,0,0-1.83-1.83H198.13a1.8,1.8,0,0,0-1.84,1.83v20.17a1.79,1.79,0,0,0,1.84,1.83H338a1.78,1.78,0,0,0,1.83-1.83",
    style: {
      fill: "#4b7571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4534",
    d: "M221.82,261.88c-4.44,0-8.37-.5-9.26-2.15-1.27-2.79-.25-7.1,0-9.89s2-3.56,4.19-3.68h.88c.89,0,1.91.12,2.92.12a21,21,0,0,0,2.79.13H225c3.93,0,8,.25,11.8.51h.88c.76,0,1.65-.13,2.67-.13s1.9-.12,2.79-.12c2.53,0,4.82.38,5.83,2.53s.63,9.13-1.14,11c-1,1.14-3.17,1.52-5.45,1.52s-4.7-.38-6.09-.38h-1c-1.52,0-3.67.12-6.08.25-2.16.13-4.82.25-7.36.25",
    style: {
      fill: "#5a8784"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4538",
    d: "M312,259.87c.13-3.13.53-6.13.92-9.12a76.65,76.65,0,0,0,.78-9h12.12c-.13,3.38-.52,6.77-.92,10.16-.26,1.69-.39,3.52-.65,5.21-2.08.91-6.38,2-12.25,2.74",
    style: {
      fill: "#5a8784"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4542",
    d: "M196.82,264.72a1.48,1.48,0,0,1-.4-1.05v-.13a2.09,2.09,0,0,0,.4,1.18m142.59,0a1.52,1.52,0,0,0,.39-1.05V243.5a1.83,1.83,0,0,0-.78-1.44,1.76,1.76,0,0,1,.78,1.31V263.8a1.45,1.45,0,0,1-.39.92m-1.31-23.05h0",
    style: {
      fill: "#f8f1e8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4546",
    d: "M337.84,265.37H198.26a1.68,1.68,0,0,1-1.44-.65,1.59,1.59,0,0,1-.4-1.18v-.66c5.63.26,17.16.53,30.91.53,27.62,0,64.81-.92,84.71-3.54-.13,1.7-.13,3.41-.13,5.11h12.18a55.31,55.31,0,0,1,.26-8,2.05,2.05,0,0,0,.79-.52c4.58-3.67,9.16-9.56,12.83-14.8h0a1.22,1.22,0,0,1,.92.39,1.8,1.8,0,0,1,.78,1.44v20.17a1.52,1.52,0,0,1-.39,1.05,1.7,1.7,0,0,1-1.44.65",
    style: {
      fill: "#496e67"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4550",
    d: "M324.08,264.87H311.84a33.13,33.13,0,0,1,.13-5.08c5.86-.78,10.29-1.69,12.37-2.87-.13,2.74-.39,5.47-.26,7.95",
    style: {
      fill: "#577f78"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4554",
    d: "M75.31,444.39H32.83a2.41,2.41,0,0,1-2.38-2.49l-2.14-10.83a2.44,2.44,0,0,1,2.5-2.5H77.33a2.51,2.51,0,0,1,2.5,2.5L77.57,441.9a2.39,2.39,0,0,1-2.26,2.49",
    style: {
      fill: "#a75f37"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4558",
    d: "M757.65,444.39h42.5a2.43,2.43,0,0,0,2.29-2.59L804.57,431A2.56,2.56,0,0,0,802,428.4H755.52a2.56,2.56,0,0,0-2.59,2.58l2.13,10.82a2.91,2.91,0,0,0,2.59,2.59",
    style: {
      fill: "#a75f37"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4562",
    d: "M395.14,444.36h42.6a2.44,2.44,0,0,0,2.3-2.58l2.17-10.72a2.58,2.58,0,0,0-2.57-2.58H393.11a2.58,2.58,0,0,0-2.58,2.58l2.17,10.72a2.65,2.65,0,0,0,2.44,2.58",
    style: {
      fill: "#a75f37"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4566",
    d: "M802.58,442h0m0,0h0m-49.32-10h0l-.15-.91h0l.15.91",
    style: {
      fill: "#eedfd7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4570",
    d: "M801.68,443.93c-3-4.26-17.07-8.22-48.29-11.88l-.16-.91a.87.87,0,0,1,.16-.61h51.33v.61L802.59,442h0a4,4,0,0,1-.91,2",
    style: {
      fill: "#9b532e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4574",
    d: "M439.91,442.86c-4.48-3.93-19.13-7.73-49-11.12l-.14-.68a1.2,1.2,0,0,1,.14-.68h51.41a6,6,0,0,1,.14.68l-2.18,10.72h0a11.34,11.34,0,0,0-.4,1.08",
    style: {
      fill: "#9b532e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4578",
    d: "M77.45,442.49h0m0,0h0m.12,0h0m0-.12h0m0,0h0m0,0h0m0-.12h0m0,0h0m0,0h0m0,0h0m0-.12h0m0,0h0m0,0h0m0-.12h0m0,0h0m0,0h0m0,0h0m0-.11h0l2.26-10.83h0L77.57,441.9h0",
    style: {
      fill: "#eedfd7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4582",
    d: "M75.78,444.39c-2.26-4.28-15.7-8.56-47.35-12.25l-.24-.95a.9.9,0,0,1,.12-.6h51.4c0,.24.12.36.12.6L77.57,442h0a2.65,2.65,0,0,1-1.79,2.38",
    style: {
      fill: "#9b532e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4586",
    d: "M827.27,430.47H5.49a3.08,3.08,0,0,1-3.07-3.07V271.73a3.08,3.08,0,0,1,3.07-3.07H827.27a3.22,3.22,0,0,1,3.23,3.07V427.4a3.12,3.12,0,0,1-3.23,3.07",
    style: {
      fill: "#a75f37"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4590",
    d: "M274.54,430.56H3.27a3.17,3.17,0,0,1-3.21-3.2V292.62a3.18,3.18,0,0,1,3.21-3.21H274.54a3.26,3.26,0,0,1,3.2,3.21V427.36a3.45,3.45,0,0,1-3.2,3.2",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4594",
    d: "M547.77,430.52H285.46a3.13,3.13,0,0,1-3.1-3.09v-37a3.13,3.13,0,0,1,3.1-3.1H547.77a3.12,3.12,0,0,1,3.09,3.1v37a3.12,3.12,0,0,1-3.09,3.09",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4598",
    d: "M547.77,380.45H285.32a3.13,3.13,0,0,1-3.1-3.09V342.19a3.13,3.13,0,0,1,3.1-3.09H547.77a3.12,3.12,0,0,1,3.09,3.09v35.17a3,3,0,0,1-3.09,3.09",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4602",
    d: "M547.77,332.21H285.46a3.13,3.13,0,0,1-3.1-3.1V292.54a3.13,3.13,0,0,1,3.1-3.09H547.77a3.12,3.12,0,0,1,3.09,3.09v36.57a3.12,3.12,0,0,1-3.09,3.1",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4606",
    d: "M829.76,430.42H558.45a3.24,3.24,0,0,1-3.23-3.22V292.46a3.24,3.24,0,0,1,3.23-3.22H829.76a3.24,3.24,0,0,1,3.22,3.22V427.2a3.24,3.24,0,0,1-3.22,3.22",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4610",
    d: "M829.76,282.94H3.23A3.22,3.22,0,0,1,0,279.87V269a3.12,3.12,0,0,1,3.23-3.07H829.76A3.21,3.21,0,0,1,833,269v10.91a3.21,3.21,0,0,1-3.22,3.07",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4614",
    d: "M830.52,282.94h0a3.14,3.14,0,0,0,2.46-3.07V269a3.12,3.12,0,0,0-2.46-3.07A3.12,3.12,0,0,1,833,269v10.91a3.14,3.14,0,0,1-2.46,3.07",
    style: {
      fill: "#f8ede4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4618",
    d: "M829.76,282.94H3.23A3.22,3.22,0,0,1,0,279.87v-2.31c42.09.31,159.47,1.23,293.43,1.23,216.62,0,476.26-2.3,529.57-13.06h7.37a3.15,3.15,0,0,1,2.46,3.08v10.9a3.15,3.15,0,0,1-2.46,3.08c-.15.15-.31.15-.61.15",
    style: {
      fill: "#d39869"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4622",
    d: "M829.76,430.42H558.29a3.24,3.24,0,0,1-3.22-3.22h0c145.64-1.69,246-4.92,255.94-18.44,11.37-15.36,14.75-73.13,15.52-119.37h2.92a3.24,3.24,0,0,1,3.22,3.23V427.35a2.77,2.77,0,0,1-2.91,3.07",
    style: {
      fill: "#d39869"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4626",
    d: "M547.77,332.21H285.46a3.13,3.13,0,0,1-3.1-3.1h0a3.13,3.13,0,0,0,3.1,3.1H547.77a3.12,3.12,0,0,0,3.09-3.1V292.54h0v36.57a3.12,3.12,0,0,1-3.09,3.1m3.09-39.67h0m0,0h0m0,0h0",
    style: {
      fill: "#a25831"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4630",
    d: "M547.77,332.21H285.46a3.13,3.13,0,0,1-3.1-3.1v-2.39c61.75-.84,241.92-.42,250.92-3.66,10.55-3.79,12.24-20.25,17-32.34a3,3,0,0,1,.56,1.68h0V329a3.15,3.15,0,0,1-3.09,3.24",
    style: {
      fill: "#d39869"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4634",
    d: "M547.77,380.45H285.32a3.13,3.13,0,0,1-3.1-3.09v-1.27c65.12-1.13,251.06-4.36,257.39-5.49,5.91-1,6.33-16.87,10.27-30.66a3.55,3.55,0,0,1,.84,2h0v35.3a3,3,0,0,1-3,3.24h0",
    style: {
      fill: "#d39869"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4638",
    d: "M547.77,430.52H285.6a3.13,3.13,0,0,1-3.1-3.09V425.6c87.06-.28,252-1.27,256.69-5.07,6.47-5.2,4.5-14.76,8.72-33.19a3.12,3.12,0,0,1,3.09,3.1v37a3.34,3.34,0,0,1-3.23,3.09h0",
    style: {
      fill: "#d39869"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4642",
    d: "M274.54,430.56h0a3.26,3.26,0,0,0,3.2-3.2V292.62h0V427.36a3.45,3.45,0,0,1-3.2,3.2m3.07-137.94h0m0,0h0m0-.13h0m0,0h0m0,0h0",
    style: {
      fill: "#a25831"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4646",
    d: "M274.54,430.56H3.26a3.17,3.17,0,0,1-3.2-3.2V421c78.26-2.3,238.62-8.07,250.27-15,14.09-8.46,19.34-87.61,25.49-116a3.1,3.1,0,0,1,1.79,2.69h0V427.36a3.23,3.23,0,0,1-3.07,3.2h0",
    style: {
      fill: "#d39869"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConsole1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/console1.9cc5905aea260e988ea46c16578e0c6c.svg";